import Vue from "vue";
import Component from "vue-class-component";

import CookieHelper from "@Scripts/Infrastructure/CookieHelper";

@Component({ name: "CookieToast" })
export default class CookieToast extends Vue {
    public isCookieToast: boolean = false;
    public isShow: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        if (!CookieHelper.isCookiePolicy()) {
            this.isCookieToast = true;
        }
    }

    public readCookieToastShow() {
        return this.isShow;
    }

    public readCookieToast() {
        this.isShow = !this.isShow;
    }

    public setCookieToast() {
        CookieHelper.setCookiePolicyAll();
        this.isCookieToast = false;
        window.location.reload();
    }

    public setOnlyTech() {
        CookieHelper.removeCookiePolicyAll();
        this.isCookieToast = false;
        window.location.reload();
    }
};